class ContractSubscriptionsController {
  initialize() {
    $(".js-unsubscribe").on(
      "click",
      function (event) {
        const subscriptionId = $(event.target).data("subscription-id");
        const contractName = $(event.target).data("contract-name");
        const organizationId = $(event.target).data("organization-id");
        this.openModal(subscriptionId, organizationId, contractName);
      }.bind(this)
    );

    $("#terminationDate").on("input", function (_event) {
      if ($("#terminationDate").val()) {
        $("#expireButton")
          .addClass("btn-danger")
          .removeClass("btn-outline-danger")
          .val("Terminate on date");
      } else {
        $("#expireButton")
          .removeClass("btn-danger")
          .addClass("btn-outline-danger")
          .val("Allow prices to expire");
      }
    });
  }

  openModal(subscriptionId, organizationId, contractName) {
    const modal = $("#unsubscribeModal");
    $("#contractName").text(contractName);
    $("#unsubscribeForm").attr(
      "action",
      `/admin/organizations/${organizationId}/contract_subscriptions/${subscriptionId}/unsubscribe`
    );
    modal.modal();
  }
}

$(document).on("turbolinks:load", () => {
  if (!$("#unsubscribeModal").length) return;
  const controller = new ContractSubscriptionsController();
  controller.initialize();
});

$(document).on("change", "#organization_role_id", (e) => {
  const selectRoleId = e.target.value;
  const preferredRoleSelect = $("#organization_preferred_shipment_role_id");
  preferredRoleSelect.empty();
  JSON.parse($("#possible_roles").val()).forEach((x) => {
    if (selectRoleId == x.organization_role_id) {
      preferredRoleSelect.append(
        `<option value=${x.shipment_role_id}>${x.shipment_role_name}</option>`
      );
    }
  });
});
